var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { PlanChangeSubsection } from '@lean-body/components/organisms';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { routes } from '@lean-body/src/route';
import { Colors } from '../styles';
import { SettingItemKeys } from '../organisms/setting_menu';
export var PlanChangeUnsubscribeCpPage = observer(function (_a) {
    var vm = _a.vm;
    if (!vm.plan)
        return null;
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(PlanChangeSubsection, { me: vm.me, changePlan: vm.plan, apiClient: vm.apiClient, accountService: vm.accountService, tracker: vm.tracker, alertPresenter: vm.alertPresenter, isUnsubscribeCpPlan: true })));
});
var styles = StyleSheet.create({
    container: {
        padding: '30px 30px 0',
        minHeight: '100vh',
        textAlign: 'center',
        backgroundColor: Colors.White,
    },
});
var PlanChangeUnsubscribeCpPageVM = /** @class */ (function () {
    function PlanChangeUnsubscribeCpPageVM(accountService, apiClient, tracker, alertPresenter) {
        Object.defineProperty(this, "accountService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "plan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tracker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "me", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submitting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this, {
            plan: observable,
            me: observable,
            submitting: observable,
        });
        this.accountService = accountService;
        this.apiClient = apiClient;
        this.alertPresenter = alertPresenter;
        this.navigate = useNavigate();
        this.tracker = tracker;
        this.load();
    }
    Object.defineProperty(PlanChangeUnsubscribeCpPageVM.prototype, "load", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var me, available;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.accountService.fetchMe()];
                        case 1:
                            me = _a.sent();
                            this.me = me;
                            available = me.payment && (me.payment.isStripePayment() || me.payment.isAmazonPayUser());
                            if (!available) {
                                this.navigate("".concat(routes.SETTING.compile(), "?key=").concat(SettingItemKeys.plan));
                                return [2 /*return*/];
                            }
                            this.apiClient.fetchChangeableUnsubscribeCpPlans().then(function (plans) {
                                _this.plan = plans[0];
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    return PlanChangeUnsubscribeCpPageVM;
}());
export { PlanChangeUnsubscribeCpPageVM };
